import api from './api';

const CART_ENDPOINTS = {
  GET_CART: '/cart',
  ADD_ITEM: '/cart/add',
  UPDATE_ITEM: '/cart/items',
  REMOVE_ITEM: '/cart/items',
  CLEAR_CART: '/cart/clear',
  APPLY_COUPON: '/cart/coupon',
  REMOVE_COUPON: '/cart/coupon',
  GET_WISHLIST: '/wishlist',
  ADD_TO_WISHLIST: '/wishlist/items',
  REMOVE_FROM_WISHLIST: '/wishlist/items',
  MOVE_TO_CART: '/wishlist/move-to-cart',
  GET_SAVED_ITEMS: '/cart/saved',
  SAVE_FOR_LATER: '/cart/save-for-later',
  MOVE_TO_CART_SAVED: '/cart/move-to-cart'
};

export const getCart = async () => {
  try {
    const response = await api.get(CART_ENDPOINTS.GET_CART);
    return response;
  } catch (error) {
    throw error;
  }
};

export const addToCart = async (productId, quantity = 1, options = {}) => {
  try {
    const response = await api.post(CART_ENDPOINTS.ADD_ITEM, {
      productId,
      quantity,
      ...options
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCartItem = async (itemId, quantity) => {
  try {
    const response = await api.put(`${CART_ENDPOINTS.UPDATE_ITEM}/${itemId}`, {
      quantity
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const removeFromCart = async (itemId) => {
  try {
    const response = await api.delete(`${CART_ENDPOINTS.REMOVE_ITEM}/${itemId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const clearCart = async () => {
  try {
    const response = await api.delete(CART_ENDPOINTS.CLEAR_CART);
    return response;
  } catch (error) {
    throw error;
  }
};

export const applyCoupon = async (couponCode) => {
  try {
    const response = await api.post(CART_ENDPOINTS.APPLY_COUPON, {
      code: couponCode
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const removeCoupon = async () => {
  try {
    const response = await api.delete(CART_ENDPOINTS.REMOVE_COUPON);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getWishlist = async () => {
  try {
    const response = await api.get(CART_ENDPOINTS.GET_WISHLIST);
    return response;
  } catch (error) {
    throw error;
  }
};

export const addToWishlist = async (productId) => {
  try {
    const response = await api.post(CART_ENDPOINTS.ADD_TO_WISHLIST, {
      productId
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const removeFromWishlist = async (itemId) => {
  try {
    const response = await api.delete(`${CART_ENDPOINTS.REMOVE_FROM_WISHLIST}/${itemId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const moveToCart = async (itemId, quantity = 1) => {
  try {
    const response = await api.post(CART_ENDPOINTS.MOVE_TO_CART, {
      itemId,
      quantity
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSavedItems = async () => {
  try {
    const response = await api.get(CART_ENDPOINTS.GET_SAVED_ITEMS);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveForLater = async (itemId) => {
  try {
    const response = await api.post(CART_ENDPOINTS.SAVE_FOR_LATER, {
      itemId
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const moveSavedToCart = async (itemId) => {
  try {
    const response = await api.post(CART_ENDPOINTS.MOVE_TO_CART_SAVED, {
      itemId
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCartSummary = async () => {
  try {
    const response = await api.get('/cart/summary');
    return response;
  } catch (error) {
    throw error;
  }
};

export const calculateShipping = async (addressId) => {
  try {
    const response = await api.post('/cart/shipping', { addressId });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAvailableCoupons = async () => {
  try {
    const response = await api.get('/coupons/available');
    return response;
  } catch (error) {
    throw error;
  }
};

export const validateCoupon = async (couponCode) => {
  try {
    const response = await api.post('/coupons/validate', { code: couponCode });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCartTotals = async () => {
  try {
    const response = await api.get('/cart/totals');
    return response;
  } catch (error) {
    throw error;
  }
};

export const mergeCart = async (guestCartId) => {
  try {
    const response = await api.post('/cart/merge', { guestCartId });
    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  getCart,
  addToCart,
  updateCartItem,
  removeFromCart,
  clearCart,
  applyCoupon,
  removeCoupon,
  getWishlist,
  addToWishlist,
  removeFromWishlist,
  moveToCart,
  getSavedItems,
  saveForLater,
  moveSavedToCart,
  getCartSummary,
  calculateShipping,
  getAvailableCoupons,
  validateCoupon,
  getCartTotals,
  mergeCart
};